import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileScreenButton } from '@fortawesome/free-solid-svg-icons';
import './InstallAppButton.css';
import { useInstallPrompt } from './useInstallPrompt';

const IOS_INSTRUCTIONS =
    'Para instalar en iPhone: toca Compartir y luego Agregar a pantalla de inicio.';
const UNAVAILABLE_MESSAGE =
    'Instalación no disponible en este navegador.';

export default function InstallAppButton({ variant = 'floating' }) {
    const {
        isIOS,
        isPrompting,
        requestInstall,
        shouldShow,
    } = useInstallPrompt();
    const [message, setMessage] = useState('');

    if (!shouldShow) {
        return null;
    }

    const handleInstall = async () => {
        setMessage('');
        const result = await requestInstall();

        if (result.status === 'ios') {
            setMessage(IOS_INSTRUCTIONS);
        } else if (result.status === 'unavailable') {
            setMessage(UNAVAILABLE_MESSAGE);
        } else if (result.status === 'dismissed') {
            setMessage('Puedes instalarla más adelante desde este botón.');
        }
    };

    const isMenu = variant === 'menu';
    const isCatalog = variant === 'catalog';

    return (
        <div
            className={`install-app install-app--${variant}`}
            data-ios={isIOS ? 'true' : 'false'}
        >
            <button
                type="button"
                className="install-app__button"
                onClick={handleInstall}
                disabled={isPrompting}
            >
                <span className="install-app__icon" aria-hidden="true">
                    <FontAwesomeIcon icon={faMobileScreenButton} />
                </span>
                <span className="install-app__copy">
                    <strong>
                        {isPrompting
                            ? 'Abriendo instalación...'
                            : isCatalog
                                ? 'Instalar'
                                : 'Instalar INK-SU'}
                    </strong>
                    {!isCatalog && (
                        <small>
                            {isMenu
                                ? 'Compra más rápido desde tu celular.'
                                : 'Compra más rápido'}
                        </small>
                    )}
                </span>
            </button>

            {message && (
                <p className="install-app__message" role="status">
                    {message}
                </p>
            )}
        </div>
    );
}
